import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

export const PermitTypeCardSkeleton: React.FC = () => (
  <Card>
    <CardContent sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1.5 }}>
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" height={28} />
          <Skeleton variant="text" width="70%" height={18} sx={{ mt: 0.5 }} />
        </Box>
        <Skeleton variant="rounded" width={80} height={24} />
      </Box>

      {/* Primary Info Grid - 4 columns */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={6} sm={3} key={i}>
            <Skeleton variant="text" width="60%" height={14} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="80%" height={18} />
          </Grid>
        ))}
      </Grid>

      {/* Applicability Section - 2 columns */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {[1, 2].map((i) => (
          <Grid item xs={12} sm={6} key={i}>
            <Skeleton variant="text" width="40%" height={14} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="60%" height={18} />
            <Skeleton variant="text" width="80%" height={14} sx={{ mt: 0.5 }} />
          </Grid>
        ))}
      </Grid>

      {/* Coverage Area & Required Documentation - 2 columns */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="30%" height={14} sx={{ mb: 0.5 }} />
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Skeleton variant="rounded" width={130} height={30} />
            <Skeleton variant="text" width="40%" height={14} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="40%" height={14} sx={{ mb: 0.5 }} />
          <Box sx={{ display: "flex", gap: 0.75 }}>
            <Skeleton variant="rounded" width={90} height={24} />
            <Skeleton variant="rounded" width={110} height={24} />
          </Box>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default PermitTypeCardSkeleton;
